import React from "react";

export default function MaintenancePage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0b1020] text-white p-6">
      <div className="max-w-5xl w-full bg-[#0b1224cc] border border-[#1f2a44] rounded-2xl shadow-2xl overflow-hidden">

        {/* Header */}
        <div className="flex justify-between items-center p-6 border-b border-white/10">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl bg-gradient-to-r from-indigo-500 to-green-500"></div>
            <div>
              <h1 className="font-semibold">Teqa SaaS</h1>
              <p className="text-xs text-gray-400">Client Portal</p>
            </div>
          </div>

          <div className="px-3 py-1 rounded-full text-xs border border-white/10 bg-black/30">
            ⏳ Maintenance
          </div>
        </div>

        {/* Hero */}
        <div className="p-8 border-b border-white/10">
          <h2 className="text-2xl font-semibold mb-3">
            Portail en maintenance • البوابة تحت الصيانة
          </h2>

          <p className="text-gray-400 text-sm">
            Nous finalisons l’application. Merci pour votre patience.
            <br />
            كنكمّلو الخدمة على التطبيق. شكراً على الصبر ديالكم.
          </p>
        </div>

        {/* Content */}
        <div className="grid md:grid-cols-2">

          {/* FR */}
          <div className="p-8 border-r border-white/10">
            <h3 className="text-lg font-semibold mb-3">
              L’application est encore en cours de préparation
            </h3>

            <p className="text-gray-400 text-sm mb-4">
              Votre compte est bien activé, mais certaines fonctionnalités
              ne sont pas encore disponibles.
            </p>

            <ul className="text-gray-400 text-sm space-y-2 list-disc ml-4">
              <li>Accès client temporairement limité</li>
              <li>Mise à jour des services</li>
              <li>Retour à la normale très bientôt</li>
            </ul>

            <div className="mt-6 flex gap-3">
              <a
                href="/logout"
                className="px-4 py-2 rounded-lg bg-indigo-600 hover:bg-indigo-700"
              >
                Se déconnecter
              </a>

              <a
                href="mailto:support@teqa.ma"
                className="px-4 py-2 rounded-lg border border-white/10"
              >
                Support
              </a>
            </div>
          </div>

          {/* AR */}
          <div className="p-8 text-right" dir="rtl">
            <h3 className="text-lg font-semibold mb-3">
              لا يزال التطبيق قيد التطوير
            </h3>

            <p className="text-gray-400 text-sm mb-4">
              الحساب ديالك مفعّل، ولكن بعض الخدمات مازال ما واجدينش.
            </p>

            <ul className="text-gray-400 text-sm space-y-2 list-disc mr-4">
              <li>ولوج العميل محدود مؤقتاً</li>
              <li>تحديث الخدمات والمزامنة</li>
              <li>الرجوع للوضع العادي قريباً</li>
            </ul>

            <div className="mt-6 flex gap-3 justify-end">
              <a
                href="/logout"
                className="px-4 py-2 rounded-lg bg-indigo-600 hover:bg-indigo-700"
              >
                تسجيل الخروج
              </a>

              <a
                href="mailto:support@teqa.ma"
                className="px-4 py-2 rounded-lg border border-white/10"
              >
                الدعم
              </a>
            </div>
          </div>

        </div>

        {/* Footer */}
        <div className="text-xs text-gray-500 p-4 border-t border-white/10 flex justify-between">
          <span>© {new Date().getFullYear()} Teqa</span>
          <span>Maintenance Mode</span>
        </div>

      </div>
    </div>
  );
}